/*
 * @Author: 桥洞里面盖小被 1353427375@qq.com
 * @Date: 2024-05-17 21:56:57
 * @LastEditors: Xia Huang 60800828+caiqingwen@users.noreply.github.com
 * @LastEditTime: 2025-04-27 10:35:15
 * @FilePath: \three-renderquick\src\utils\render.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import * as THREE from 'three';
import { CSS3DObject, CSS3DSprite } from 'three/addons/renderers/CSS3DRenderer.js';
import { CSS2DRenderer, CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js';
import { Line2 } from 'three/examples/jsm/lines/Line2.js';



/**
 * @description: 生成停车位的结合体
 * @param {*} center 停车位中心
 * @param {*} longerEdge 长边长度
 * @param {*} shorterEdge 短边长度
 * @param {*} angle 旋转角度
 * @return {*}
 */
export function generateParkingSpacesGeometry(center, longerEdge, shorterEdge, angle) {
  // 生成几何体
  const planeGeometry = new THREE.PlaneGeometry(longerEdge, shorterEdge);
  // 创建一个变换矩阵
  const matrix = new THREE.Matrix4();
  // 设置位置
  matrix.setPosition(center[0], center[1], 0);
  // 设置旋转
  const rotationMatrix = new THREE.Matrix4().makeRotationZ(angle);
  // 合并旋转和位置矩阵
  matrix.multiply(rotationMatrix);
  // 应用矩阵变换到几何体
  planeGeometry.applyMatrix4(matrix);
  return planeGeometry;
}


/**
 * @description: 生成停车位背景几何体
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function generateParkingSpacesBackgroundGeometry(vertices) {
  // 进行ShapeGeometry构建实体
  // 设置节点坐标
  const points = [];
  vertices.forEach(vertex => {
    points.push(new THREE.Vector2(vertex[0], vertex[1]));
  });
  points.pop();
  // 创建二维形状
  const shape = new THREE.Shape(points);
  // 创建车位几何体
  const geometry = new THREE.ShapeGeometry(shape);
  // 创建一个变换矩阵
  const matrix = new THREE.Matrix4();
  // 设置位置
  matrix.setPosition(0, 0, -0.001);
  geometry.applyMatrix4(matrix);
  return geometry;
}

/**
 * @description: 生成阻车器几何体
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function generateArresterGeometry(vertices) {
  // 进行ShapeGeometry构建实体
  // 设置节点坐标
  const points = [];
  vertices.forEach(vertex => {
    points.push(new THREE.Vector2(vertex[0], vertex[1]));
  });
  points.pop();
  // 创建二维形状
  const shape = new THREE.Shape(points);
  // 创建车位几何体
  const geometry = new THREE.ShapeGeometry(shape);
  // 创建一个变换矩阵
  const matrix = new THREE.Matrix4();
  // 设置位置
  matrix.setPosition(0, 0, 0.002);
  geometry.applyMatrix4(matrix);
  return geometry;
}




/**
 * @description: 生成墙体几何体
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function generateWallGeometry(vertices) {
  // 进行ExtrudeGeometry构建实体
  const points = [];
  vertices.forEach(vertex => {
    points.push(new THREE.Vector2(vertex[0], vertex[1]));
  });
  // points.pop();
  // 创建几何体
  // 创建二维形状
  const shape = new THREE.Shape(points);
  // 创建挤压设置
  const extrudeSettings = {
    depth: 0.1,         // 挤压深度
    bevelEnabled: false // 不使用倒角
  };
  // 创建三维墙体
  const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
  return geometry;
}

/**
 * @description: 生成电梯几何体
 * @param {*} vertices 坐标
 * @return {*}
 */
export function generatePassengerElevatorGeometry(vertices) {
  // 进行ExtrudeGeometry构建实体
  // 设置节点坐标
  const points = [];
  vertices.forEach(vertex => {
    points.push(new THREE.Vector2(vertex[0], vertex[1]));
  });
  points.pop();
  // 创建二维形状
  const shape = new THREE.Shape(points);
  // 创建挤压设置
  const extrudeSettings = {
    depth: 0.3, // 挤压深度
    bevelEnabled: false // 不使用倒角
  };
  // 创建三维墙体
  const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
  return geometry;
}




/**
 * @description: 渲染停车位函数
 * @param {*} material 材质
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function renderParkingSpaces(material, center, longerEdge, shorterEdge, angle) {
  // console.log('Hex color:', material.color.getHex().toString(16));
  // 创建平面几何体
  const textPlaneGeometry = new THREE.PlaneGeometry(longerEdge, shorterEdge); // 这里的尺寸可以根据需要调整
  const mesh = new THREE.Mesh(textPlaneGeometry, material);
  mesh.rotateZ(angle)
  // 设置位置
  mesh.position.set(center[0], center[1], 0); // 这里的Z轴位置可以根据需要调整，确保在车位上方
  // 添加userData以便后续识别停车位文本
  mesh.userData.type = 'parkingSpace';
  return mesh


    // // 进行ShapeGeometry构建停车位实体
    // // 设置节点坐标
    // const points = [];
    // vertices.forEach(vertex => {
    //     points.push(new THREE.Vector2(vertex[0], vertex[1]));
    // });
    // points.pop();
    // // 创建二维形状
    // const shape = new THREE.Shape(points);
    // // 创建车位几何体
    // const geometry = new THREE.ShapeGeometry(shape);
    // const mesh = new THREE.Mesh(geometry, material);
    // // 物体接收光源
    // mesh.castShadow = true;
    // mesh.receiveShadow = true;
    // mesh.userData.type = 'parkingSpace'; // 添加userData以便后续识别停车场
    // // // 创建停车位文本信息
    // // if (parkingSpaceText !== null) {
    // //   const textDiv = document.createElement('div');
    // //   textDiv.className = 'parking-space-text';
    // //   textDiv.fontSize = '25px';
    // //   textDiv.textContent = parkingSpaceText;
    // //   const parkingSpaceLabel = new CSS3DObject(textDiv);
    // //   parkingSpaceLabel.rotateZ(parkingSpaceTextAngle)
    // //   parkingSpaceLabel.position.set(center[0], center[1], 0.002); // 这里的Z轴位置可以根据需要调整，确保在车位上方
    // //   parkingSpaceLabel.scale.set(0.003, 0.003, 0.003);
    // //   mesh.add(parkingSpaceLabel);
    // // }
    // return mesh;
}

/**
 * @description: 创建停车位几何体
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function createParkingSpaceGeometry(vertices) {
  // 进行ShapeGeometry构建停车位实体
    // 设置节点坐标
    const points = [];
    vertices.forEach(vertex => {
        points.push(new THREE.Vector3(vertex[0], vertex[1], 0));
    });
    points.pop();
    // 创建二维形状
    const shape = new THREE.Shape(points);
    // 创建车位几何体
    const geometry = new THREE.ShapeGeometry(shape);
    // const extrudeSettings = {
    //     depth: 0.00001, // 挤压深度
    //     bevelEnabled: false // 不使用倒角
    // };
    // // 创建车位几何体
    // const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
    return geometry;
}



/**
 * @description: 渲染停车位边界线函数
 * @param {*} material 材质
 * @param {*} vertices 顶点坐标
 * @param {*} lineWidth 线宽
 * @return {*}
 */
export function renderParkingSpaceBorder(material, vertices, lineWidth = 0.5) {
    // // 进行ShapeGeometry构建实体
    // // 设置节点坐标
    // const points = [];
    // vertices.forEach(vertex => {
    //   points.push(new THREE.Vector3(vertex[0], vertex[1], 0));
    // });
    // points.pop()
    // // 创建几何体
    // const geometry = new THREE.BufferGeometry().setFromPoints(points);
    // // 创建线
    // const line = new THREE.LineLoop(geometry, material);
    // line.userData.type = 'parkingSpaceBorder'; // 添加userData以便后续识别停车位边框线
    // return line;
    // 进行LineGeometry构建实体
    // 设置节点坐标
    const points = [];
    vertices.forEach(vertex => {
      points.push(vertex[0], vertex[1], 0);
    });
    // points.pop()

    // 创建几何体
    const geometry = new LineGeometry();
    geometry.setPositions(points);

    // 创建线材质
    const lineMaterial = new LineMaterial({
        color: material.color,
        linewidth: lineWidth, // 设置线的宽度
        dashed: material.dashed || false
    });

    lineMaterial.resolution.set(window.innerWidth, window.innerHeight); // 必须设置resolution

    // 创建线
    const line = new Line2(geometry, lineMaterial);
    line.userData.type = 'parkingSpaceBorder'; // 添加userData以便后续识别停车位边框线
    return line;
}



/**
 * @description: 渲染停车位文本函数
 * @param {*} center 中心坐标
 * @param {*} longerEdge 停车位长边长度
 * @param {*} shorterEdge 停车位短边长度
 * @param {*} text 文本内容
 * @param {*} angle 旋转角度
 * @return {*}
 */
export function renderParkingSpaceText(center, longerEdge, shorterEdge, text, angle) {
    let canvas = document.getElementById('text-canvas');
    const context = canvas.getContext('2d');
    
    // 设置 canvas 大小
    canvas.width = 512;
    canvas.height = 128;

    // 设置文本样式
    context.font = '100px Arial';
    context.fillStyle = '#ffffff';
    context.textAlign = 'center';
    context.textBaseline = 'middle';

    // 绘制文本
    context.fillText(text, canvas.width / 2, canvas.height / 2);

    // // 创建CanvasTexture
    // const texture = new THREE.CanvasTexture(canvas);
    // // 创建平面几何体
    // const textPlaneGeometry = new THREE.PlaneGeometry(longerEdge, shorterEdge); // 这里的尺寸可以根据需要调整
    // const textPlaneMaterial = new THREE.MeshBasicMaterial({ map: texture , transparent: true});

    // 图像信息
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    // 创建一个纹理加载器
    let dataTexture = new THREE.DataTexture(imageData.data, canvas.width, canvas.height, THREE.RGBAFormat);
    dataTexture.needsUpdate = true
    // 创建平面几何体
    const textPlaneGeometry = new THREE.PlaneGeometry(longerEdge, shorterEdge); // 这里的尺寸可以根据需要调整
    const textPlaneMaterial = new THREE.MeshBasicMaterial({map: dataTexture , transparent: true});
    textPlaneMaterial.map.flipY = true;
    // const textPlaneMaterial = new THREE.MeshBasicMaterial({ color : 0xff0000 });
    const textPlaneMesh = new THREE.Mesh(textPlaneGeometry, textPlaneMaterial);
    textPlaneMesh.rotateZ(angle)
    // 设置位置
    textPlaneMesh.position.set(center[0], center[1], 0.002); // 这里的Z轴位置可以根据需要调整，确保在车位上方
    // 添加userData以便后续识别停车位文本
    textPlaneMesh.userData.type = 'parkingSpaceNumberByMesh';


    return textPlaneMesh;
}



/**
 * @description: 渲染停车位文本函数
 * @param {*} center 中心坐标
 * @param {*} text 文本内容
 * @return {*}
 */
export function renderParkingSpaceTextByCSS2DRender(center, text) {
  // 创建textDiv
  const textDiv = document.createElement('div');
  textDiv.textContent = text; 
  textDiv.style.textAlign = 'center';
  textDiv.style.textShadow = '#fff 1px 0 0, #fff 0 1px 0, #fff -1px 0 0, #fff 0 -1px 0';

  const object = new CSS2DObject(textDiv);
  // 使用LOD技术处理
  // const lod = new THREE.LOD();
  // lod.addLevel(object, 80);
  // // 空模型
  // const emptyObject = new THREE.Object3D();
  // lod.addLevel(emptyObject, 100);
  // lod.position.set(center[0], center[1], 0.002); // 这里的Z轴位置可以根据需要调整，确保在车位上方
  // lod.userData.type = 'parkingSpaceNumberByCSS2DRender';
  // return lod;
  // 不使用LOD技术处理
  object.position.set(center[0], center[1], 0.002);
  object.userData.type = 'parkingSpaceNumberByCSS2DRender';
  return object;

}



/**
 * @description: 渲染墙壁函数
 * @param {*} material 材质
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function renderWall(material, vertices) {
    // 进行ExtrudeGeometry构建实体
    // 设置节点坐标
    // console.log("输入的vertices", vertices)
    const points = [];
    vertices.forEach(vertex => {
      points.push(new THREE.Vector2(vertex[0], vertex[1]));
    });
    // points.pop();

    // 创建几何体
    // 创建二维形状
    const shape = new THREE.Shape(points);
    // 创建挤压设置
    const extrudeSettings = {
      depth: 0.1,         // 挤压深度
      bevelEnabled: false // 不使用倒角
    };
    
    // 创建三维墙体
    const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
    const mesh = new THREE.Mesh(geometry, material);

  // 物体接收光源
  mesh.castShadow = true;
  // mesh.receiveShadow = true;
  mesh.userData.type = 'wall'; // 添加userData以便后续识别墙壁
  return mesh;
}

/**
 * @description: 创建墙壁几何体
 * @param {*} vertices 顶点
 * @return {*}
 */
export function createWallGeometry(vertices) {
  // 进行ExtrudeGeometry构建实体
    // 设置节点坐标
    // console.log("输入的vertices", vertices)
    const points = [];
    vertices.forEach(vertex => {
      points.push(new THREE.Vector2(vertex[0], vertex[1]));
    });
    // points.pop();

    // 创建几何体
    // 创建二维形状
    const shape = new THREE.Shape(points);
    // 创建挤压设置
    const extrudeSettings = {
      depth: 0.1,         // 挤压深度
      bevelEnabled: false // 不使用倒角
    };
    
    // 创建三维墙体
    const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
    return geometry;

}



// /**
//  * @description: 渲染墙壁函数
//  * @param {*} material 材质
//  * @param {*} vertices 顶点坐标
//  * @return {*}
//  */
// export function renderWall(material, vertices) {
//     // 进行ExtrudeGeometry构建实体
//     // 设置节点坐标
//     const points = [];
//     vertices.forEach(vertex => {
//       points.push(new THREE.Vector2(vertex[0], vertex[1]));
//     });
//     // points.pop();

//     // 创建几何体
//     // 创建二维形状
//     const shape = new THREE.Shape(points);
//     // 创建挤压设置
//     const extrudeSettings = {
//       depth: 0.1,         // 挤压深度
//       bevelEnabled: false // 不使用倒角
//     };
    
//     // 创建三维墙体
//     const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
//     const mesh = new THREE.Mesh(geometry, material);
//     // 物体接收光源
//     mesh.castShadow = true;
//     mesh.receiveShadow = true;
//     mesh.userData.type = 'wall'; // 添加userData以便后续识别墙壁
//     return mesh;
// }


/**
 * @description: 渲染车道线函数
 * @param {*} material 材质
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function renderLaneLines(material, vertices) {
    // 设置节点坐标
    const points = [];
    vertices.forEach(vertex => {
      points.push(new THREE.Vector2(vertex[0], vertex[1], 0));
    });
    points.pop()
    // 创建几何体
    const geometry = new THREE.BufferGeometry().setFromPoints(points);
    // 创建线
    const line = new THREE.LineLoop(geometry, material);
    // const line = new THREE.Line(geometry, material);
    line.userData.type = 'laneLines'; // 添加userData以便后续识别车道线
    return line;
  }


/**
 * @description: 渲染电梯实体函数
 * @param {*} material 材质
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function renderPassengerElevator(material, vertices) {
    // 进行ExtrudeGeometry构建实体
    // 设置节点坐标
    const points = [];
    vertices.forEach(vertex => {
      points.push(new THREE.Vector2(vertex[0], vertex[1]));
    });
    points.pop();
    // 创建二维形状
    const shape = new THREE.Shape(points);
    // 创建挤压设置
    const extrudeSettings = {
      depth: 0.3, // 挤压深度
      bevelEnabled: false // 不使用倒角
    };
    // 创建三维墙体
    const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
    const mesh = new THREE.Mesh(geometry, material);
    // 创建电梯模型语义信息
    // 计算电梯的中心位置
    // const center = [0, 0];
    // vertices.forEach(vertex => {
    //   center[0] += vertex[0];
    //   center[1] += vertex[1];
    // });
    // center[0] /= vertices.length;
    // center[1] /= vertices.length;
    // mesh.add(renderElevatorText(name, center, 0.4));
    // 物体接收光源
    mesh.castShadow = true;
    mesh.userData.type = 'elevator'; // 添加userData以便后续识别电梯
    return mesh;
}

/**
 * @description: 创建电梯几何体
 * @param {*} vertices 顶点
 * @return {*}
 */
export function createPassengerElevatorGeometry(vertices) {
  // 进行ExtrudeGeometry构建实体
    // 设置节点坐标
    const points = [];
    vertices.forEach(vertex => {
      points.push(new THREE.Vector2(vertex[0], vertex[1]));
    });
    points.pop();
    // 创建二维形状
    const shape = new THREE.Shape(points);
    // 创建挤压设置
    const extrudeSettings = {
      depth: 0.3, // 挤压深度
      bevelEnabled: false // 不使用倒角
    };
    // 创建三维墙体
    const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
    return geometry;
}

/**
 * @description: 渲染出入口实体函数
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function renderEntranceExit(vertices) {
    // 利用CSS2DRenderer进行渲染
    // iconDiv
    const iconDiv = document.createElement('img');
    iconDiv.src = 'icon/entranceExit.png'
    iconDiv.width = 26;
    iconDiv.height = 26;
    iconDiv.classList.add('exitEntrance-icon');
    // 文字Div
    const textDiv = document.createElement('div');
    textDiv.style.fontSize = '12px'
    textDiv.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
    textDiv.textContent = '出入口'; // 替换为你需要的文本
    textDiv.style.textAlign = 'center';
    // 创建CSS2DObject
    const containerDiv = document.createElement('div');
    containerDiv.className = "text-container"
    containerDiv.style.display = 'flex';
    containerDiv.style.flexDirection = 'column';
    containerDiv.style.alignItems = 'center';
    containerDiv.appendChild(textDiv);
    containerDiv.appendChild(iconDiv);
    const object = new CSS2DObject(containerDiv);
    object.position.set(vertices[0], vertices[1], 0.01);
    return object;
}

/**
 * @description: 渲染出口实体函数
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function renderEntrance(vertices) {
    const textureLoader = new THREE.TextureLoader();
    const spriteTexture = textureLoader.load('exit.png');
    const spriteMaterial = new THREE.SpriteMaterial({ map: spriteTexture});
    const sprite = new THREE.Sprite(spriteMaterial);
    sprite.userData.type = 'eixt'; // 添加userData以便后续识别出口
    sprite.position.set(vertices[0][0], vertices[0][1], 0);
    sprite.position.z += 0.15;
    sprite.scale.set(0.3,0.3,0.3);
    return sprite;
}

/**
 * @description: 渲染入口实体函数
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function renderExit(vertices) {
    const textureLoader = new THREE.TextureLoader();
    const spriteTexture = textureLoader.load('entranc.png');
    const spriteMaterial = new THREE.SpriteMaterial({ map: spriteTexture});
    const sprite = new THREE.Sprite(spriteMaterial);
    sprite.userData.type = 'entrance'; // 添加userData以便后续识别入口
    sprite.position.set(vertices[0][0], vertices[0][1], 0);
    sprite.position.z += 0.15;
    sprite.scale.set(0.3,0.3,0.3);
    return sprite;
}

/**
 * @description: 渲染停车位背景函数
 * @param {*} material 材质
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function renderParkingSpaceBackground(material, vertices) {
    // 进行ShapeGeometry构建实体
    // 设置节点坐标
    const points = [];
    vertices.forEach(vertex => {
      points.push(new THREE.Vector2(vertex[0], vertex[1]));
    });
    points.pop();
    // 创建二维形状
    const shape = new THREE.Shape(points);
    // 创建车位几何体
    const geometry = new THREE.ShapeGeometry(shape);
    const mesh = new THREE.Mesh(geometry, material);
    mesh.userData.type = 'parkingSpaceBackground'; // 添加userData以便后续识别停车位
    mesh.position.z = -0.001;
    // 物体接收光源
    mesh.castShadow = true;
    mesh.receiveShadow = true;
    return mesh;
}

/**
 * @description: 创建停车位背景几何体
 * @param {*} vertices 顶点
 * @return {*}
 */
export function createParkingSpaceBackgroundGeometry(vertices) {
  // 进行ShapeGeometry构建实体
    // 设置节点坐标
    const points = [];
    vertices.forEach(vertex => {
      points.push(new THREE.Vector2(vertex[0], vertex[1]));
    });
    points.pop();
    // 创建二维形状
    const shape = new THREE.Shape(points);
    // 创建车位几何体
    const geometry = new THREE.ShapeGeometry(shape);
    // 物体接收光源
    // mesh.castShadow = true;
    // mesh.receiveShadow = true;
    return geometry;
}


/**
 * @description: 渲染地面的函数
 * @param {*} material 材质
 * @param {*} vertices 顶点坐标
 * @return {*}
 */
export function renderGround(material, vertices) {
    // 设置节点坐标
    const points = [];
    vertices.forEach(vertex => {
      points.push(new THREE.Vector2(vertex[0], vertex[1]));
    });
    points.pop();
    // 创建二维形状
    const shape = new THREE.Shape(points);
    // 创建车位几何体
    const geometry = new THREE.ShapeGeometry(shape);
    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.z = -0.002;
    mesh.userData.type = 'ground'; // 添加userData以便后续识别地面
    // 物体接收光源
    mesh.castShadow = true;
    mesh.receiveShadow = true;
    return mesh;
}


/**
 * @description: 渲染电梯文本函数
 * @param {*} elevatorText 文本内容
 * @param {*} position 文本位置
 * @return {*}
 */
export function renderElevatorText(elevatorText, position, height = 0.4) {
  // 利用CSS2DRenderer进行渲染
  const iconDiv = document.createElement('div');
  const iconImg = document.createElement('img');
  iconImg.src = 'icon/elevator.png';
  iconImg.width = 30;
  iconImg.height = 30;
  iconImg.style.display = 'block'; // 确保图片为块级元素
  iconDiv.appendChild(iconImg);
  iconDiv.classList.add('exitEntrance-icon');
  iconDiv.style.display = 'flex';
  iconDiv.style.flexDirection = 'column';
  iconDiv.style.alignItems = 'center';
  iconDiv.style.justifyContent = 'center'; // 垂直方向居中对齐

  // 创建textDiv
  const textDiv = document.createElement('div');
  textDiv.style.fontSize = '20px'
  textDiv.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
  textDiv.textContent = elevatorText; 
  textDiv.style.textAlign = 'center';
  textDiv.style.width = '100%'; 

  // 创建containerDiv
  const containerDiv = document.createElement('div');
  containerDiv.className = "text-container"
  containerDiv.style.display = 'flex';
  containerDiv.style.flexDirection = 'column';
  containerDiv.style.alignItems = 'center';
  containerDiv.style.justifyContent = 'center'; // 垂直方向居中对齐

  // 追加子元素到containerDiv
  containerDiv.appendChild(textDiv);
  containerDiv.appendChild(iconDiv);

  const object = new CSS2DObject(containerDiv);


  // 不使用LOD技术
  object.position.set(position[0], position[1], height);
  return object;
}



/**
 * @description: 渲染文本函数
 * @param {*} elevatorText 文本内容
 * @param {*} position 文本位置
 * @return {*}
 */
export function renderText(text, position, height = 0.4) {
  // 创建textDiv
  const textDiv = document.createElement('div');
  textDiv.style.fontSize = '20px'
  textDiv.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
  textDiv.textContent = text; 
  textDiv.style.textAlign = 'center';

  const object = new CSS2DObject(textDiv);
  // // 使用LOD技术处理
  // const lod = new THREE.LOD();
  // lod.addLevel(object, 3);
  // // 空模型
  // const emptyObject = new THREE.Object3D();
  // lod.addLevel(emptyObject, 8);
  // lod.position.set(position[0], position[1], height); // 这里的Z轴位置可以根据需要调整，确保在车位上方
  // return lod;

  // 不使用LOD技术
  object.position.set(position[0], position[1], height);
  return object;
}





/**
 * @description: 加载模型
 * @param {*} path 模型路径
 * @return {*}
 */
export function renderCarModel(path) {
  return new Promise((resolve, reject) => {
    const gltfLoader = new GLTFLoader();
    gltfLoader.load(
      path,
      function (gltf) {
        gltf.scene.rotation.x = Math.PI / 2;
        resolve(gltf.scene);
      },
      undefined,
      function (error) {
        console.error('An error happened while loading the model:', error);
        reject(error);
      }
    );
  });
}




/**
 * @description: 加载GLTF模型函数
 * @param {*} path 模型路径
 * @param {*} position 位置
 * @param {*} parkingSpaceMaxLen 停车场最长边
 * @param {*} rotation 旋转
 * @return {*}
 */
export function renderGTLFCarModel(carModel, position, parkingSpaceMaxLen, rotation, height = 0.04) {
  const box = new THREE.Box3().setFromObject(carModel);
  const size = box.getSize(new THREE.Vector3());
  const carMaxLen = Math.max(size.x, size.y);
  const scale = parkingSpaceMaxLen / carMaxLen;
  carModel.scale.set(scale, scale, scale);
  // 设置位置和旋转
  carModel.position.set(position[0], position[1], height);
  carModel.rotation.y = rotation + Math.PI / 2;
  return carModel;
  // return new Promise((resolve, reject) => {
  //   const loader = new GLTFLoader();
  //   loader.load(path, function (gltf) {
  //     // 因为模型是以y轴朝上，构建的场景是z轴朝上，所以先旋转，让朝向相同。
  //     gltf.scene.rotation.x = Math.PI / 2;
  //     // 计算模型的长和宽,并缩放
  //     const box = new THREE.Box3().setFromObject(gltf.scene);
  //     const size = box.getSize(new THREE.Vector3());
  //     const carMaxLen = Math.max(size.x, size.y);
  //     const scale = parkingSpaceMaxLen / carMaxLen;
  //     gltf.scene.scale.set(scale, scale, scale);
  //     // 设置位置和旋转
  //     gltf.scene.position.set(position[0], position[1], height);
  //     gltf.scene.rotation.y = rotation  + Math.PI / 2;
  //     // 添加模型
  //     resolve(gltf.scene);
  //   }, undefined, function (error) {
  //     reject(error);
  //   });
  // });
}



// export function renderBatchedMesh(geometry, material) {

// }

/**
 * @description: 将两个点拓展为一条闭合曲线，宽度为delta
 * @param {*} A 点1
 * @param {*} B 点2
 * @param {*} delta 间距
 * @return {*}
 */
export function expandPoint(A, B, delta = 0.01) {
  let result = [];
  let length_AB = Math.sqrt((B[0] - A[0]) ** 2 + (B[1] - A[1]) ** 2);
  let unit_vector_AB = [(B[0] - A[0]) / length_AB, (B[1] - A[1]) / length_AB];
  let normal_vector_AB = [-unit_vector_AB[1], unit_vector_AB[0]];
  let pointA1 = [A[0] + normal_vector_AB[0] * delta, A[1] + normal_vector_AB[1] * delta];
  let pointB1 = [B[0] + normal_vector_AB[0] * delta, B[1] + normal_vector_AB[1] * delta];
  let pointA2 = [A[0] - normal_vector_AB[0] * delta, A[1] - normal_vector_AB[1] * delta];
  let pointB2 = [B[0] - normal_vector_AB[0] * delta, B[1] - normal_vector_AB[1] * delta];
  result.push(pointA1, pointB1, pointB2, pointA2, pointA1);
  return result;
}




